import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import whyChooseService from "../../service/whyChoose";
import { WhyChoose, WhyChooseState } from "../../@type/whychoose";

export const getWhyChoose = createAsyncThunk(
    "get/getWhyChoose",
    async () => {
      const { data } = await whyChooseService.get({});
      return data;
    }
  );
  export const getByWhyChooseId = createAsyncThunk(
    "get/getByIDCategory",
    async (id: any) => {
      const { data } = await whyChooseService.getById(id);
      return data;
    }
  );
  export const postWhyChoose = createAsyncThunk(
    "post/postWhyChoose",
    async (WhyChooseData: any) => {
      const { data } = await whyChooseService.post(WhyChooseData);
      return data;
    }
  );

    export const updateWhyChoose = createAsyncThunk(
    "update/updateWhyChoose",
    async ({ id, a }: { id: any, a: WhyChoose }) => {
      const { data } = await whyChooseService.updateById(id, a);
      return data;
    }
  );
const initialState: WhyChooseState = {
  whyChooseList: [],
  whyChooseDetail: {
    id:0,
   title:"",
    description:""
  }
};

const WhyChooseSlice = createSlice({
  name: "WhyChoose",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getWhyChoose.fulfilled, (state, action) => {
      state.whyChooseList = action.payload.data;
    });
    builder.addCase(postWhyChoose.fulfilled, (state, action) => {
      state.whyChooseList.push(action.payload);
    }); 
    builder.addCase(getByWhyChooseId.fulfilled, (state, action) => {
      state.whyChooseDetail = action.payload.WhyChoose;
    });
      builder.addCase(updateWhyChoose.fulfilled, (state, action) => {
          state.whyChooseDetail = action.payload.data;
        });
  },
});

export default WhyChooseSlice.reducer;
